import { render, staticRenderFns } from "./DesignStudioLeftMenus.vue?vue&type=template&id=379bf14c"
import script from "./DesignStudioLeftMenus.vue?vue&type=script&lang=js"
export * from "./DesignStudioLeftMenus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports